import { render, staticRenderFns } from "./RenglonesData.vue?vue&type=template&id=0c62d468&"
import script from "./RenglonesData.vue?vue&type=script&lang=js&"
export * from "./RenglonesData.vue?vue&type=script&lang=js&"
import style0 from "./RenglonesData.vue?vue&type=style&index=0&id=0c62d468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports